// AiAssistIcon.js
// Compact inline AI icon button using the central IC_agentic_ai.svg asset
// Aligned with the AmploFly interactive design tokens

import React from 'react';
import PropTypes from 'prop-types';
import './AgenticSupport.css';

const agenticIcon = require('../../common/images/IC_agentic_ai.svg');

const AiAssistIcon = ({ 
    onClick, 
    tooltip = 'AI Context Suggestion', 
    disabled = false, 
    size = 'small', // 'small' (20x20px) | 'medium' (24x24px for toolbar)
    loading = false, 
    pulse = true,
    theme = 'dark' // 'dark' | 'light'
}) => {
    
    const handleButtonClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!disabled && !loading && onClick) {
            onClick(e);
        }
    };

    return (
        <button
            type="button"
            className={`ai-assist-icon-btn ${size} ${theme} ${pulse && !loading && !disabled ? 'pulse' : ''} ${loading ? 'loading' : ''} ${disabled ? 'disabled' : ''}`}
            onClick={handleButtonClick}
            disabled={disabled}
            title={tooltip}
        >
            <img
                src={agenticIcon.default || agenticIcon}
                alt="AI Assist"
                className="ai-assist-icon-img"
            />
        </button>
    );
};

AiAssistIcon.propTypes = {
    onClick: PropTypes.func,
    tooltip: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium']),
    loading: PropTypes.bool,
    pulse: PropTypes.bool,
    theme: PropTypes.oneOf(['dark', 'light']),
};

export default AiAssistIcon;
